var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_502_105403)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.7083,
    cy: 20.9896,
    r: 16.2357,
    fill: "url(#paint0_linear_502_105403)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.7083,
    cy: 20.9896,
    r: 16.2357,
    fill: "url(#paint1_radial_502_105403)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_502_105403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6987 29.0732V17.4021H16.0268V15.2497H21.2222V29.0732H18.6987Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_502_105403",
    x: -29.5348,
    y: -27.2535,
    width: 96.4856,
    height: 96.4861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.0037
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_105403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_105403",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_502_105403",
    x: 0.951368,
    y: 0.173536,
    width: 35.3473,
    height: 43.9757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.53799
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_105403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_105403",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_105403",
    x1: -10.3285,
    y1: 42.533,
    x2: 66.1664,
    y2: -3.67615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#73C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B46A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_502_105403",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.455 75.6956) rotate(-145.948) scale(221.518 74.2714)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop1);
export default __webpack_public_path__ + "static/media/Top1.652213184990ba7cab277d3f6b27f7e3.svg";
export { ForwardRef as ReactComponent };